import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BellRinging, Check } from "@phosphor-icons/react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get("/notifications?limit=100");
    setItems(data);
  };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="space-y-5">
      <div className="rise flex items-end justify-between flex-wrap gap-3">
        <div>
          <span className="label-eyebrow">Inbox</span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-1">Notifications</h1>
        </div>
        {items.some((n) => !n.read) && (
          <button onClick={markAll} data-testid="notifs-mark-all"
            className="px-3 py-2 rounded-lg bg-[#0F2537] text-white text-sm font-bold inline-flex items-center gap-1">
            <Check size={14} weight="bold" /> Mark all read
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="card-default p-10 text-center">
          <BellRinging size={28} weight="duotone" className="mx-auto text-[#E05D3A]" />
          <p className="mt-3 text-[#0F2537]/70">You're all caught up.</p>
        </div>
      ) : (
        <div className="card-default overflow-hidden">
          <ul className="divide-y divide-[#E2E0D8]">
            {items.map((n) => {
              const inner = (
                <div className={`px-5 py-4 hover:bg-black/[0.02] flex items-start gap-3 ${!n.read ? "bg-[#E05D3A]/5" : ""}`}>
                  {!n.read && <span className="mt-2 w-2 h-2 rounded-full bg-[#E05D3A] shrink-0" />}
                  <div className="flex-1 min-w-0">
                    <div className={`${!n.read ? "font-bold" : "font-semibold"}`}>{n.title}</div>
                    <div className="text-sm text-[#0F2537]/70 mt-0.5">{n.body}</div>
                    <div className="text-xs text-[#0F2537]/40 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                  <span className="text-xs uppercase tracking-widest text-[#0F2537]/50 font-bold mt-1">
                    {n.type.replace(/_/g, " ")}
                  </span>
                </div>
              );
              return (
                <li key={n.id} data-testid={`notif-row-${n.id}`}>
                  {n.link ? <Link to={n.link}>{inner}</Link> : inner}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
